import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import { updateDevicesPageMapViewport, updateDevicesPageSelectedDeviceId } from 'redux/actions';
import { isItBundle } from 'common/utils/deviceTwinUtils';
import { getDonorUnitFromBundleMembers } from 'common/utils/helpers';
import './DeviceTable.css';

import { reformatUserPreferencesArrIntoObj } from './utils';
import {
  Status,
  LOADING_CIRCLE,
  defaultDeviceTableSearchBody,
  DEVICES_PAGE_TAB,
  USER_PREFERENCE_SETS,
  DEFAULT_PIVOT_TAB_COLUMNS,
  DEFAULT_ECHO_TAB_COLUMNS,
  DEFAULT_ALL_DEVICES_TAB_COLUMNS
} from 'common/utils/constants';
import DeviceTableHeader from './DeviceTableHeaders/DeviceTableHeader';
import DeviceTableRow from './DeviceTableRow';
import { searchComponentFilteredDevicesV2 } from 'redux/actions';
import { selectUserPreferences } from 'redux/selectors';
import { memoOnce, selectUserPreferenceList, selectUserCategoryPreferences } from 'redux/UserPreferences';
import {
  getPivotTabColumns,
  getEchoTabColumns,
  getAllDevicesTabColumns,
  getAlarmMapColumns
} from './DeviceTableColumns';

class DeviceTable extends Component {
  constructor(props) {
    super(props);

    this.rowIndex = 0;
  }

  render() {
    const columnsPreferences = this.props.columnsPreferences?.[0]?.state;
    if (this.props.forAlarmMap) {
      this.columns = getAlarmMapColumns(
        this,
        reformatUserPreferencesArrIntoObj(columnsPreferences?.allDevicesTab ?? DEFAULT_ALL_DEVICES_TAB_COLUMNS)
      );
    } else if (this.props.activeTab === DEVICES_PAGE_TAB.pivot) {
      this.columns = getPivotTabColumns(
        this,
        reformatUserPreferencesArrIntoObj(columnsPreferences?.pivotTab ?? DEFAULT_PIVOT_TAB_COLUMNS)
      );
    } else if (this.props.activeTab === DEVICES_PAGE_TAB.echo) {
      this.columns = getEchoTabColumns(
        this,
        reformatUserPreferencesArrIntoObj(columnsPreferences?.echoTab ?? DEFAULT_ECHO_TAB_COLUMNS)
      );
    } else {
      this.columns = getAllDevicesTabColumns(
        this,
        reformatUserPreferencesArrIntoObj(columnsPreferences?.allDevicesTab ?? DEFAULT_ALL_DEVICES_TAB_COLUMNS)
      );
    }
    let pageSize = 0;
    if (this.props.deviceTableSet.devices) {
      pageSize = this.props.deviceTableSet.devices.length;
    }

    let overlay = null;
    if (
      this.props.error &&
      (this.props.deviceTableSet.devices == null || this.props.deviceTableSet.devices.length < 1)
      // (Object.values(debugSearchResponse.devices) == null || Object.values(debugSearchResponse.devices).length < 1)
    ) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">Error </div>
            <div className="Global_Table_ErrorOverlay_Message">
              An unknown error occurred while getting the list of devices. If this problem persists, please contact us
              at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
          </div>
        </div>
      );
    }

    if (this.props.fetching) {
      overlay = <div className="DeviceTable_LoadingCircle_Overlay">{LOADING_CIRCLE}</div>;
    }

    let searchFilteredDeviceTableBody = {
      ...defaultDeviceTableSearchBody,
      next: this.props.deviceTableSet.continuationToken
    };

    let lastColumnId = null;
    if (this.columns) {
      lastColumnId = this.columns[this.columns.length - 1].id;
    }

    let devicesData = [];
    if (!this.props.forAlarmMap) {
      devicesData = this.props.deviceTableSet.devices;
      const obj = {};
      devicesData.forEach((item) => {
        let id = item?.id ? item.id : item.bundleId;
        if (!obj[id]) {
          obj[id] = item;
        }
      });
      devicesData = Object.values(obj);
    } else {
      devicesData = this.props.devices;
    }

    return (
      <ScrollReactTable
        withFixedColumns={true}
        id={'deviceTable'}
        forAlarmMap={this.props.forAlarmMap}
        showPagination={false}
        infiniteContainerHeight={436}
        resizable={true}
        sortable={false}
        dataLength={2}
        // minRows={this.props.forAlarmMap ? Object.values(debugSearchResponse.devices).length : 11}
        minRows={this.props.forAlarmMap ? this.props.devices?.length : 11}
        noDataText={''}
        overlay={overlay}
        fetching={this.props.fetching}
        className={'-highlight DeviceTable Global_Table'}
        defaultPageSize={0}
        pageSize={this.props.forAlarmMap ? this.props.devices?.length : pageSize}
        infinite={this.props.forAlarmMap ? false : true}
        hasMoreResults={this.props.deviceTableSet.hasMoreResults}
        activeTab={this.props.activeTab}
        searchComponent={'deviceTable'}
        searchFilteredDeviceTableBody={searchFilteredDeviceTableBody}
        filterDictionary={this.props.filterDictionary}
        devicesTableSort={this.props.devicesTableSort}
        lastColumnId={lastColumnId}
        fetchData={() => {
          this.props.dispatch(
            searchComponentFilteredDevicesV2(
              this.props.activeTab,
              'deviceTable',
              searchFilteredDeviceTableBody,
              this.props.filterDictionary,
              this.props.devicesTableSort /*TODO swap in sorts*/,
              true
            )
          );
        }}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (rowInfo && rowInfo.index < this.props.deviceTableSet.devices.length) {
                let isBundle = isItBundle(rowInfo.original);
                let selectedId = isBundle ? rowInfo.original.bundleId : rowInfo.original.deviceId;
                const mainDevice = isBundle
                  ? getDonorUnitFromBundleMembers(rowInfo.original.members)
                  : rowInfo.original;
                const newLocation = [mainDevice?.location?.lat || 0, mainDevice?.location?.lon || 0];
                const viewport = {
                  center: newLocation,
                  zoom: this.props.zoom < 18 ? 18 : 17
                };

                this.props.dispatch(updateDevicesPageMapViewport(viewport));
                this.props.dispatch(updateDevicesPageSelectedDeviceId(selectedId));
              }
              if (handleOriginal) {
                handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
              }
            }
          };
        }}
        getTrProps={(state, rowInfo, column) => {
          this.rowIndex = rowInfo;
          return {
            className: 'rowStyle'
          };
        }}
        data={devicesData}
        //data={Object.values(debugSearchResponse.devices)}
        columns={this.columns}
        TrComponent={(props, index) => (
          <DeviceTableRow {...props} index={this.rowIndex} forAlarmMap={this.props.forAlarmMap} />
        )}
        TheadComponent={(props) => (
          <DeviceTableHeader
            {...props}
            hasCheckbox={this.props.hasCheckbox}
            onSelectDeviceGroup={this.props.onSelectDeviceGroup}
          />
        )}
      />
    );
  }
}

const selectPreferenceList = memoOnce(selectUserPreferenceList);

export default connect((store) => {
  let deviceTableSet = [];
  let filterDictionary = {};
  let devicesTableSort;

  const activeTab = store.ui.devicesPage.activeTab;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    deviceTableSet = store.data.pivotDeviceSets?.deviceTable;
    devicesTableSort = store.data.pivotDeviceSets?.deviceTable?.sort;
    filterDictionary = store.data.pivotFilterDictionary;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    deviceTableSet = store.data.echoDeviceSets?.deviceTable;
    devicesTableSort = store.data.echoDeviceSets?.deviceTable?.sort;
    filterDictionary = store.data.echoFilterDictionary;
  } else {
    deviceTableSet = store.data.allDeviceSets?.deviceTable;
    devicesTableSort = store.data.allDeviceSets?.deviceTable?.sort;
    filterDictionary = store.data.allDevicesFilterDictionary;
  }

  const userPreferences = selectUserPreferences(store);
  const columnsPreferences = selectUserCategoryPreferences(userPreferences, USER_PREFERENCE_SETS.COLUMNS_SET);
  const columnsPreferenceList = selectPreferenceList(userPreferences, USER_PREFERENCE_SETS.COLUMNS_SET);

  return {
    activeTab,
    deviceTableSet,
    filterDictionary,
    devicesTableSort,
    // either protected or factory API is pending
    fetching:
      store.statuses['searchComponentFilteredDevicesV2_deviceTable_' + activeTab] === Status.PENDING ||
      // getting updated list
      store.statuses['doGetFactoryList'] === Status.PENDING ||
      store.statuses['doGetProtectedList'] === Status.PENDING ||
      // adding all devices in the bundle or single device to factory
      store.statuses['doAddFactoryDevice-0'] === Status.PENDING ||
      store.statuses['doAddFactoryDevice-1'] === Status.PENDING ||
      store.statuses['doAddFactoryDevice-2'] === Status.PENDING ||
      // deleting all devices in the bundle or single device from factory
      store.statuses['doDeleteFactoryDevice-0'] === Status.PENDING ||
      store.statuses['doDeleteFactoryDevice-1'] === Status.PENDING ||
      store.statuses['doDeleteFactoryDevice-2'] === Status.PENDING ||
      // adding all devices in the bundle or single device to protected
      store.statuses['doAddProtectedDevice-0'] === Status.PENDING ||
      store.statuses['doAddProtectedDevice-1'] === Status.PENDING ||
      store.statuses['doAddProtectedDevice-2'] === Status.PENDING ||
      // deleting all devices in the bundle or single device from protected
      store.statuses['doDeleteProtectedDevice-0'] === Status.PENDING ||
      store.statuses['doDeleteProtectedDevice-1'] === Status.PENDING ||
      store.statuses['doDeleteProtectedDevice-2'] === Status.PENDING ||
      // getting user preferences
      userPreferences.loading ||
      columnsPreferences.loading ||
      // getting user groups
      store.statuses['GET-User-DeviceGroups'] === Status.PENDING ||
      // get device polygons
      store.statuses['GET-User-DevicePolygons'] === Status.PENDING,
    error: store.statuses['searchComponentFilteredDevicesV2_deviceTable_' + activeTab] === Status.FAILURE,
    protectedList: store.data.protectedList,
    factoryList: store.data.factoryList,
    userPermissions: store.data?.rolePermissions?.permissions,
    columnsPreferences: columnsPreferenceList,
    deviceTableWidth: store.ui.devicesPage.deviceTableWidth,
    zoom: store.ui.devicesPage.mapZoom
  };
})(DeviceTable);
